import { Box, keyframes } from '@mui/material';

const glowPulse = keyframes`
  0%, 100% {
    box-shadow: 0 0 5px var(--glow-color),
                0 0 10px var(--glow-color),
                0 0 20px var(--glow-color);
  }
  50% {
    box-shadow: 0 0 10px var(--glow-color),
                0 0 20px var(--glow-color),
                0 0 40px var(--glow-color),
                0 0 60px var(--glow-color);
  }
`;

const GlowBorder = ({
  children,
  color = '#00ff88',
  intensity = 1,
  pulseSpeed = 2,
  borderRadius = 16,
  active = true,
}) => {
  if (!active) {
    return <>{children}</>;
  }

  return (
    <Box
      sx={{
        position: 'relative',
        '--glow-color': color,
        borderRadius: `${borderRadius}px`,
        animation: `${glowPulse} ${pulseSpeed}s ease-in-out infinite`,
        opacity: intensity,
      }}
    >
      {children}
    </Box>
  );
};

export default GlowBorder;
